import { useState, useEffect } from 'react';
import './App.css';
import FAQS from './faqs';
import Feedback from './feedback';
import MCQ from './components/mcq';

import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyCzTyIr6pbEmQbJis4qzgSVhILMvX1-Ccc",
  authDomain: "revise-gpt.firebaseapp.com",
  projectId: "revise-gpt",
  storageBucket: "revise-gpt.appspot.com",
  messagingSenderId: "1005522690606",
  appId: "1:1005522690606:web:e424ab864d056aecae75bf",
  measurementId: "G-7B47SQ43RW"
};

const MCQQuestionList = ({ difficulty, questions, mcqsSubmitted }) => {

  let mcqs = []
  for(let i=0; i<5; i+=1) {
    mcqs.push(<MCQ 
      index={i}
      question={questions[difficulty][i]}
      submitted={mcqsSubmitted[difficulty]}
    />)
  }

  return (
    <div className='question-list'>
      <h2>Question Set {difficulty}</h2>
      {mcqs}
    </div>
  )

}

const Entity = ({ index, question, answer, evaluation, setter }) => {

  let evaluationText = ""

  if(evaluation.status === "correct") evaluationText = "You're correct"
  else if(evaluation.status === "wrong") evaluationText = "You've made a mistake.\n" + evaluation.reason_if_wrong
  else if(evaluation.status === "unattempted") evaluationText = "You didn't attempt this.\n" + evaluation.explanation

  return (
    <div className='entity'>
      <p className='question'>{index+1}. {question.question}</p>
      <textarea className='answer' onInput={e => setter(e.target)} value={answer} maxLength={1000}/>
      { evaluationText && <p className={'evaluation ' + evaluation.status}>{evaluationText}</p> }
    </div>
  )

}

const TextQuestionList = ({ difficulty, questions, evaluations, answers, setAnswers }) => {

  let entities = []
  for(let i=0; i<5; i+=1) {

    const setAnswersForDifficultyAtIndex = ({ value }) => {
      const newAnswers = answers[difficulty]
      newAnswers[i] = value
      setAnswers({...answers, [difficulty]: newAnswers})
    }

    const question = (questions[difficulty] !== null) ? questions[difficulty][i] : ""
    const answer = (answers[difficulty] !== null) ? answers[difficulty][i] : ""
    const evaluation = (evaluations[difficulty] !== null) ? evaluations[difficulty][i] : ""

    entities.push(<Entity
      index={i}
      question={question}
      answer={answer}
      evaluation={evaluation}
      setter={setAnswersForDifficultyAtIndex} />)
  }
  return (
    <div className='question-list'>
      <h2>Question Set {difficulty}</h2>
      {entities}
    </div>
  )

}

const Suggestion = ({ value, setter }) => {
  return <p className='suggestion' onClick={() => { setter(value) }}>{value}</p>
}

const SuggestionList = ({ setter }) => {

  const suggestions = ['javascript,', 'chemistry,', 'philosophy ']

  return(
    <div className='suggestion-list'>
      or try
      {suggestions.map((suggestion, idx) => <Suggestion value={suggestion} setter={setter} /> )}.
    </div>
  )

}

function App() {

  const firebaseApp = initializeApp(firebaseConfig);
  const analytics = getAnalytics(firebaseApp);

  const domain = process.env.REACT_APP_DOMAIN

  const emptyArray = () => [...Array(5)].map(() => "")

  const [sessionId, setSessionId] = useState("default")

  const [topic, setTopic] = useState("")
  const [difficulty, setDifficulty] = useState(0)
  const [questions, setQuestions] = useState({1: emptyArray(), 2: emptyArray(), 3: emptyArray(), 4: emptyArray()})
  const [answers, setAnswers] = useState({1: emptyArray(), 2: emptyArray(), 3: emptyArray(), 4: emptyArray()})
  const [evaluations, setEvaluations] =  useState({1: emptyArray(), 2: emptyArray(), 3: emptyArray(), 4: emptyArray()})
  const [mcqsSubmitted, setMcqsSubmitted] = useState({1: false, 2: false, 3: false, 4: false})

  const [isLoading, setLoading] = useState(false)
  const [loadingMessage, setLoadingMessage] = useState("")

  useEffect(() => {
    // ping server on load so it warms up
    fetch(domain + '/healthcheck') 
    // page visited on load
    logEvent(analytics, 'website_visited');
  }, [])

  useEffect(() => {
    setLoadingMessage(
      difficulty === 0
        ? 'Generating questions for you...'
        : 'Evaluating and generating the next set of questions for you...'
    );
  }, [difficulty]);

  const handleTopicSubmit = async () => {

    setLoading(true)
    try {
      const response = await fetch(domain + '/question', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 1, topic }),
      });
      const data = await response.json()
      setDifficulty(1)
      setQuestions({...questions, 1: data.questions})
      setSessionId(data.sessionId)
      setLoading(false)
    } catch (error) {
      console.error('Error fetching questions:', error)
    }

  }

  const handleMCQAnswersSubmit = async () => {

    setLoading(true)
    try {
      const response = await fetch(domain + '/question', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 2, sessionId, topic, difficulty }),
      });
      const data = await response.json()
      const nextDifficulty = difficulty+1
      setMcqsSubmitted({...mcqsSubmitted, [difficulty]: true})
      setQuestions({...questions, [nextDifficulty]: data.questions})
      setDifficulty(nextDifficulty)
      setLoading(false)
    } catch (error) {
      console.error('Error submitting answers and questions:', error)
    }

  }

  const handleTextAnswersSubmit = async () => {

    setLoading(true)
    try {
      const response = await fetch(domain + '/question', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 2, sessionId, topic, difficulty, questions: questions[difficulty], answers: answers[difficulty] }),
      });
      const data = await response.json()
      const nextDifficulty = difficulty+1
      setQuestions({...questions, [nextDifficulty]: data.questions})
      setEvaluations({...evaluations, [difficulty]: data.evaluations})
      setDifficulty(nextDifficulty)
      setLoading(false)
    } catch (error) {
      console.error('Error submitting answers and questions:', error)
    }

  }

  const handleFeedbackSend = async (feedback) => {
    try {
        const response = await fetch(domain + '/log', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ sessionId, feedback }),
        })
      } catch (error) {
        console.error('Error fetching questions:', error)
      }
  }

  return (
    <div className="App">
      <div className='title'>
        <h1>Test yourself on any topic with AI</h1>
      </div>
      <div className='topic'>
        <input type='text' onChange={e => setTopic(e.target.value)}/>
        <button className='button-50' onClick={handleTopicSubmit}>let's start</button>
      </div>
      <SuggestionList setter={setTopic} />
      {[...Array(difficulty).keys()].map((level, idx) => 
        // <TextQuestionList difficulty={level+1} questions={questions} evaluations={evaluations} answers={answers} setAnswers={setAnswers} />)}
        <MCQQuestionList difficulty={level+1} questions={questions} mcqsSubmitted={mcqsSubmitted}/>)}
      {(difficulty > 0) && (difficulty < 5) && <button className='button-50' onClick={handleMCQAnswersSubmit} disabled={isLoading}>submit answers</button>}
      <br/>
      {isLoading && loadingMessage}
      {(difficulty === 5) && <h3>Thanks for trying out Revise GPT.</h3>}
      <FAQS />
      <Feedback handleFeedbackSend={handleFeedbackSend}/>
    </div>
  )

}

export default App;
